import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'what_are_individual_workers_basic_wages_based_upon_select_all_t'

export const dataPointDefinition = {
  retracedId: 'what_are_individual_workers_basic_wages_based_upon_select_all_t',
  name: "What are individual worker's basic wages based upon?",
  description:
    'The intent of this question is to understand what factors go into determining individual worker basic wages. \r\r\n\r\r\nAre worker\'s basic wages based only on legal requirements? Or the worker having certain skills / experience? Please select all that apply.\r\r\n\r\r\nFor example, if the facility basic wages for some workers are based on the minimum legal requirements and others on legal requirements AND their length of employment, the response would be "Legal Wage Requirements" and "Length of Employment".\r\r\n\r\r\n"Basic wage" means the rate of pay for a standard work period excluding additional payments like bonuses and overtime.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'LEGAL_OR_CONTRACTUAL_AGREEMENT_REQUIREMENTS',
      text: 'Legal (or contractual agreement) requirements',
      externalIds: [
        {
          id: 'wb-10--2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'LIVING_WAGE_ESTIMATE',
      text: 'Living Wage Estimate',
      externalIds: [
        {
          id: 'wb-wag-37x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SKILLS',
      text: 'Skills',
      externalIds: [
        {
          id: 'wb-10--2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EXPERIENCE',
      text: 'Experience',
      externalIds: [
        {
          id: 'wb-10--2-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'LENGTH_OF_EMPLOYMENT',
      text: 'Length of Employment',
      externalIds: [
        {
          id: 'wb-10--2-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PERFORMANCE',
      text: 'Performance',
      externalIds: [
        {
          id: 'wb-10--2-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wb-10--2-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-10--2-6f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'wb-10--2-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'LEGAL_OR_CONTRACTUAL_AGREEMENT_REQUIREMENTS',
                'LIVING_WAGE_ESTIMATE',
                'SKILLS',
                'EXPERIENCE',
                'LENGTH_OF_EMPLOYMENT',
                'PERFORMANCE',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-36',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8210,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
